import styled from 'styled-components';

const StyledSection = styled.section`
  ${props => (props.styles)};
`;

export default StyledSection;
